// Ensure all dialogs/popovers are closed before turbo caches the page. Without
// this, these may appear as "underneath" the page when navigating back to a
// cached page. See this related turbo issue:
// https://github.com/hotwired/turbo/issues/1239
document.addEventListener("turbo:before-cache", () => {
  document.querySelectorAll("dialog").forEach((dialog) => dialog.close());
  document
    .querySelectorAll("[popover]")
    .forEach((popover) => popover.hidePopover());
});
